import { getAuthToken } from 'helpers/cookie.helpers'

export const getAuthTokenFromCookie = () => getAuthToken()

export const selectPredictionAuth = (state) => {
  const token = getAuthToken()
  const isDemoMode = Boolean(state.predictionMarket?.isDemoMode)
  const isLoggedIn = Boolean(state.auth?.loginData?.accessToken || token) || isDemoMode
  const user = state.user?.user
  const wallet = state.user?.selectedWallet
  const demoWallet = state.predictionMarket?.demoWallet

  return {
    isLoggedIn,
    userInfo: {
      user: { id: isDemoMode ? (user?.id ?? 1) : user?.id },
      wallet: isDemoMode && demoWallet
        ? {
            balance: demoWallet.balance ?? 0,
            currency: demoWallet.currency || 'USD'
          }
        : {
            balance: wallet?.amount ?? 0,
            currency: wallet?.currency?.code || wallet?.currency?.symbol || ''
          }
    }
  }
}
